import script from "./navigations.vue?vue&type=script&setup=true&lang=js"
export * from "./navigations.vue?vue&type=script&setup=true&lang=js"

import "./navigations.vue?vue&type=style&index=0&id=4758a63c&lang=css"

const __exports__ = script;

export default __exports__